import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
@Component({
    selector: 'app-query-view-page',
    templateUrl: 'query-view.page.html',
    styleUrls: [
      './query-view.page.scss',
    ]
  })
  export class QueryViewPage implements OnInit {

    constructor(
      private router: Router,
      public authService: GtrakAuthService,
      private route: ActivatedRoute,
      private toasterService: ToasterService,
      private systemSettingService: SystemSettingService,
    ) { }
   queryResult: any[] = [];
    loaded: boolean=false;
    columns:any;
    webReport:string="";
    currentDate = new Date();
    async ngOnInit() {
     this.loaded = true;
     this.loadData();
    }
   async loadData(){
       this.loaded = false;
      await this.systemSettingService.getCustomerSiteReportsByQuery(this.route.snapshot.paramMap.get('id')).then((res) => {
      this.queryResult = res.queryResult;
      this.webReport=res.webReport;
      if (res?.queryResult?.length > 0) {
        this.queryResult = res.queryResult.map((item: any) => {
          const newItem: any = {};
          Object.keys(item).forEach(key => {
            const newKey = key.replace(/_/g, ' ');
            newItem[newKey] = item[key];
          });
          return newItem;
        });
  
      this.columns = Object.keys(this.queryResult[0]);
        }
      });
     
      this.loaded = true;
    }
  getTotal(columnName: string): number {
    if (!this.queryResult || this.queryResult.length === 0) return 0;
    return this.queryResult.reduce((sum, row) => {
      const val = parseFloat(row[columnName]);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);
      
  }
 
  }